import React from 'react';
import { useParams } from 'react-router-dom';
import { useAppConfig } from '@/modules/config';
import { topicGardenEnabled } from '@/conditional_feature/topic_garden_enabled';
import { TopicCreateOrUpdatePage } from '@/modules/topic_garden';
import TopicView from './TopicView';

/**
 * Edit-mode route for a topic (`/topics/:id/edit`).
 *
 * With the garden flag on, the edit experience is the shared component-driven
 * form for ANY type, so we commit to the stable `TopicCreateOrUpdatePage` immediately —
 * before the topic's type is known — and keep a single view mounted for the whole
 * edit lifecycle. This mirrors `ReadTopicGate`: committing up front avoids
 * swapping the mounted view mid-flow (legacy `TopicView` while the type is
 * unknown, then the component-driven form once the topic loads), which would both
 * strand a dismissing Ionic interstitial (#524) and drop the freshly-fetched form
 * values.
 *
 * With the flag off (the default), this renders exactly
 * `<TopicView initialMode="update" />` — the legacy path, byte for byte.
 */
const UpdateTopicGate: React.FC = () => {
  const { topicId } = useParams<{ topicId: string }>();
  const { features } = useAppConfig();

  if (topicGardenEnabled(features)) {
    return <TopicCreateOrUpdatePage initialMode="update" topicId={topicId} />;
  }

  return <TopicView initialMode="update" topicId={topicId} />;
};

export default UpdateTopicGate;
